module.exports = __webpack_public_path__ + "static/media/Group 131.5c50b590.svg";